import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

import styles from './Highlight.module.css';
import { animateCSS, dateDiff } from '../../helpers/globals';

// Images
import hamburderMenuIcon from '../../assets/icons/Hamburder Menu Icon.svg';

import My_Photo_Round_1x from './../../assets/HomePage/Highlight/My_Photo_Round_1x.webp';
import My_Photo_Round_2x from './../../assets/HomePage/Highlight/My_Photo_Round_2x.webp';

import My_Photo_Round_Mobile_1x from './../../assets/HomePage/Highlight/Mobile/My_Photo_Round_1x.webp';
import My_Photo_Round_Mobile_2x from './../../assets/HomePage/Highlight/Mobile/My_Photo_Round_2x.webp';

const dataProfileLocal = {
    fullName: 'Jagdish Chopde',
    title: 'UI/UX Enthusiast',
    titleDetails: 'Design Lead, Technical Project Manager, UI/UX Architect',
    ctaTitle: 'View Overall Corporate Journey',
    ctaValue: '/experience'
};

const dataHighlightsLocal = {
    totalTitle: 'Total Work Experience',
    totalValue: dateDiff(new Date("May, 2, 2012")),
    currentTitle: 'TCS Work Experience',
    currentValue: dateDiff(new Date("Nov, 28, 2022"))
};

export default function HighlightComponent() {
    function openMenuPanel() {
        const navBarPanel = document.getElementById("navBarPanel");

        if (navBarPanel) {
            navBarPanel.style.display = "block";
            animateCSS('#navBarPanel', 'animate__slideInDown');
        } else {
            navBarPanel.style.display = "none";
        }
    }

    // Profile & Experience Or Analytics Data Filling
    const urlSearchParams = new URLSearchParams(window.location.search);
    const showExpQuery = urlSearchParams.get('showexp');
    const initialShowDBData = showExpQuery === 'true' ? false : true;

    const [showDBData, setShowDBData] = useState(initialShowDBData);

    const [dataProfile, setDataProfile] = useState(dataProfileLocal);
    const [dataHighlights, setDataHighlights] = useState({});

    const setData = useCallback((profile = dataProfileLocal, highlights = dataHighlightsLocal) => {
        setDataProfile(profile);
        setDataHighlights(highlights);
    }, []);

    const setDBData = useCallback(async () => {
        const url = 'https://jagdishchopde-profile-default-rtdb.firebaseio.com/.json';
        try {
            const response = await fetch(url);
            if (!response.ok) {
                setData();
                setShowDBData(false);
            }

            const json = await response.json();
            const profileDB = {
                ...dataProfileLocal,
                title: json.dataProfile.profileTitle,
                titleDetails: json.dataProfile.profileRoles,
                ctaTitle: json.dataProfile.CTATitle,
                ctaValue: json.dataProfile.CTAValue
            };
            const highlightsDB = {
                totalTitle: 'Total Website Visits',
                totalValue: json.dataAnalytics.TotalHits.toLocaleString('en-IN'),
            };

            setData(profileDB, highlightsDB);

            fetch("https://jagdishchopde-profile-default-rtdb.firebaseio.com/dataAnalytics.json", {
                method: "PUT",
                body: JSON.stringify({ TotalHits: +json.dataAnalytics.TotalHits + 1 }),
            });
        } catch (error) {
            // console.error(error.message);
            setData();
            setShowDBData(false);
        }
    }, [setData]);

    // Fill Profile and Hightlighs data according to selection
    useEffect(() => {
        if (showDBData) {
            setDBData();
        } else {
            setData();
        }
    }, [showDBData, setDBData, setData])


    return (
        <>
            {/* Mobile Highlight */}
            <section className={styles.mobileHighlight}>
                <button id='hamburderMenuIconBtn' className={styles.hamburderMenuIcon} onClick={openMenuPanel}>
                    <img src={hamburderMenuIcon} alt="Menu Icon" />
                </button>
                <span className={styles.profileWebsiteTitle}>PROFILE WEBSITE</span>
                <h1> {dataProfile.fullName} </h1>
                <picture>
                    <source type="image/webp" media="(min-width:300px)" srcSet={My_Photo_Round_Mobile_1x + ' 1x, ' + My_Photo_Round_Mobile_2x + ' 2x'} alt="Portrait of Jagdish Chopde" />
                    <img src={My_Photo_Round_Mobile_1x} className={styles.myRoundPhoto} alt="Portrait of Jagdish Chopde" />
                </picture>
                <h2> {dataProfile.title} </h2>
                <h3> {dataProfile.titleDetails} </h3>
            </section>

            {/* Desktop Highlight */}
            <section className={styles.leftHighlight + ' section animate__animated animate__fadeInUp animate__slow'}>
                <picture>
                    <source type="image/webp" media="(min-width:300px)" srcSet={My_Photo_Round_1x + ' 1x, ' + My_Photo_Round_2x + ' 2x'} alt="Portrait of Jagdish Chopde" />
                    <img src={My_Photo_Round_1x} className={styles.myRoundPhoto} alt="Portrait of Jagdish Chopde" />
                </picture>
                <div className={styles.myTitles}>
                    <h1> {dataProfile.fullName} </h1>
                    <h2> {dataProfile.title} </h2>
                    <h3> {dataProfile.titleDetails} </h3>
                </div>
            </section>

            <section className={styles.rightHighlight + ' section animate__animated animate__fadeInUp animate__slow'}>
                <div className={styles.experiences} onClick={() => setShowDBData(!showDBData)}>
                    <div className={styles.totalExperience}>
                        <span className={styles.expLabel}> {dataHighlights.totalTitle} </span>
                        <span className={styles.expTitle}> {dataHighlights.totalValue} </span>
                    </div>
                    {!showDBData && <div className={styles.tcsExperience}>
                        <span className={styles.expLabel}> {dataHighlights.currentTitle} </span>
                        <span className={styles.expTitle}> {dataHighlights.currentValue} </span>
                    </div>}
                </div>
                <div className={styles.allExpNavigation}>
                    <Link to={dataProfile.ctaValue} className={styles.chip_btn}> {dataProfile.ctaTitle} </Link>
                </div>
            </section>
        </>
    );
}